import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Payload {
  documentId: string;
  claimId: string;
}

const useChangeClaimDocumentQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.put(API_URL.CLAIMS_DOCUMENT_BY_CLAIM_ID(payload?.claimId), {
      document_id: payload?.documentId,
    })
  );

  return {
    changeClaimDocument: mutateAsync,
    isChangeClaimDocumentLoading: isLoading,
  };
};

export default useChangeClaimDocumentQuery;
